// -------------------------------
// TEXTUAL EXPORTS

// Display to the console
module.exports.console = {
  START_MESSAGE_DEV: `SME Cap Advisory Development Environment`,
  START_MESSAGE_PROD: `smecapadvisory.com © Dylan Carter`
}


// Display to the console
module.exports.tabbar = {
  GENERAL: `SME Cap Advisory`
}

// Throughout application
module.exports.app = {
  TITLE_LOGIN: `Login`,
  TITLE_JOIN: `Get started`
}